// ==============================================================================
// Imports
// ==============================================================================

import React, { useState, useRef }from "react";
import Select from "react-select";
import {Icon} from "semantic-ui-react";
import useOnClickOutside from "../../hooks/useOnClickOutside";

// ==============================================================================
// Filter Component
// Filters Displayed in the Sidebar
// ==============================================================================
/**
 *
 * @param props
 * @returns {JSX.Element}
 * This is a custom implementation of the select component by the react-select library. Two variations here
 * at this point where one is a classic implementation without much customization whereas the other one is a
 * deconstructed version created specifically to render the dropdown and select/filter items from an icon.
 * To use customized Filter, supply isIcon prop to the component.
 */

const Filter = props => {
    const ref = useRef();
    const selectRef = useRef();
    const { handleFilter, options, placeholder, value, isDisabled, isMulti, isIcon } = props;
    const [open, setOpen] = useState(false);
    useOnClickOutside(ref, () => setOpen(false));

    const toggleOpen = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!open);
        if (selectRef.current) {
            selectRef.current.focus()
        }
    }

    let filterClassName = 'filter-dropdown';
    if (open) {
        filterClassName += ' active';
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
        }),
        container: () => ({
            width: open ? "250px" : 0,
            position: 'absolute',
            top: '54px',
            right: '5px',
            opacity: open ? 1 : 0,
            boxShadow: `0px 2px 3px 0px rgba(0,0,0,0.20)`,
        }),
        control: () => ({
            borderBottom: "1px solid lightgrey",
            backgroundColor: "white",
            height: "auto",
            minHeight: "70px",
            padding: "10px 3px",
            display: "flex",
        }),
        valueContainer: () => ({
            display: "flex",
            flex: 1,
            padding: "2px 8px",
            flexFlow: "wrap-reverse",
            alignItems: "flex-start",
        }),
        placeholder: () => ({
            display: "none"
        }),
        menu: () => ({
            margin: 0,
        }),
        input: () => ({
            width: '100%',
            padding: '5px 5px 5px 25px',
            border: '1px solid lightgrey',
            cursor: 'text',
            textAlign: "left",
            marginBottom: "8px",
            background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23b3b3b3' viewBox='0 0 512 512'%3E%3Cpath d='M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z'/%3E%3C/svg%3E\") no-repeat 5px center",
            backgroundSize: "15px 15px",
        }),
        indicatorsContainer: () => ({
            position: "absolute",
            top: "8px",
            right: "5px"
        }),
        menuList: () => ({
            maxHeight: 300,
            textAlign: "justify",
            overflow: "auto",
            paddingBottom: 4,
            paddingTop: 4,
            position: "relative",
            boxSizing: "border-box",
            backgroundColor: "white",
        }),
    };

    return (
        isIcon
            ? (
                <div ref={ref} style={{display: "inline"}}>
                    <Icon
                        className={filterClassName}
                        onClick={toggleOpen}
                        name={"filter"}
                        style={{color: open ? "#337ab7" : ""}}
                    />
                    <Select
                        ref={selectRef}
                        menuIsOpen={open}
                        styles={customStyles}
                        onChange={handleFilter}
                        options={options}
                        placeholder={placeholder}
                        isSearchable={true}
                        isClearable={true}
                        isDisabled={isDisabled}
                        value={value}
                        isMulti={isMulti}
                        components={{
                            DropdownIndicator: null,
                        }}
                    />
              </div>
            )
            : (
                <div className="sidebar-filter-container">
                  <Select
                      onChange={handleFilter}
                      options={options}
                      placeholder={placeholder}
                      isSearchable={true}
                      isClearable={true}
                      isDisabled={isDisabled}
                      value={value}
                      isMulti={isMulti}
                  />
              </div>
            )
    );
};

export default Filter;
